import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  GO_TO_CANCEL_STEP: `${cleanedFilename(__filename)}-go-to-cancel-step`,
};
